import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'ReferenceGroup' })({
    root: {
        background: '#F5F5F5',
        borderRadius: 28,
        padding: 20,
        marginBottom: 20
    },
    summary: {
        display: 'flex',
        alignItems: 'center',
        gap: 16
    },
    avatar: {
        background: '#fff',
        cursor: 'pointer'
    },
    text: {
        flex: 1
    },
    title: {
        textTransform: 'capitalize',
        fontWeight: 600
    },
    subtitle: {
        color: '#979797',
        fontSize: 12,
        marginTop: 4,
        textTransform: 'capitalize'
    },
    list: {
        marginTop: 20,
        borderRadius: 18,
        background: '#FAFAFA'
    },
    more: {
        boxShadow: 'none',
        borderRadius: 100,
        fontSize: 14,
        transition: 'all 0.2s ease-out'
    }
});
